import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Gallery.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';

import './Fonts/fonts.css'; 

function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [additionalTextIndex, setAdditionalTextIndex] = useState(0);

  const handleSlideChange = (selectedIndex) => {
    setCurrentIndex(selectedIndex);
  };

  const handleAdditionalTextChange = (selectedIndex) => {
    setAdditionalTextIndex(selectedIndex);
  };

  const renderText = () => {
    switch (currentIndex) {
      case 0:
        return (
          <div className="text-container">
            <h2>The Roots of Innovation</h2>
            <p>
              Founded in Benghazi in 1959 by two visionary engineers, LEO began as a small consultancy with big ambitions. Over the years, it has grown into a leading engineering office that has played a pivotal role in Libya’s development,
              from urban planning and infrastructure to educational and healthcare facilities.
            </p>
          </div>
        );
      case 1:
        return (
          <div className="text-container">
            <h2>A Legacy of Excellence</h2>
            <p>
              Every project tells a story of challenges met with innovative solutions. Our commitment to quality, sustainability, and 
              precision has left a mark on Libya’s landscape, helping to drive its modernization and growth.
            </p>
          </div>
        );
      case 2:
        return (
          <div className="text-container">
            <h2>Designing the Future</h2>
            <p>
              At the forefront of engineering consultancy, LEO is shaping the future by embracing new technologies and methodologies. Our work extends beyond borders, bringing global best practices to local projects.
            </p>
          </div>
        );
      case 3:
        return (
          <div className="text-container">
            <h2>Icons of Resilience</h2>
            <p>
              In the early 1980s, LEO embarked on an ambitious project to create a vast residential development that today stands 
              as a testament to brilliant engineering and foresight.
            </p>
          </div>
        );
      case 4:
        return (
          <div className="text-container">
            <h2>Beacons of Heritage</h2>
            <p>
              Constructed in 1968, this architectural marvel is one of Benghazi’s oldest and most revered cultural landmarks.
            </p>
          </div>
        );
      case 5:
        return (
          <div className="text-container">
            <h2>Architectural Visions</h2>
            <p>
              The Roots of Innovation: Founded in Benghazi in 1959 by two visionary engineers...
            </p>
          </div>
        );
      case 6:
        return (
          <div className="text-container">
            <h2>Commitment to Sustainability</h2>
            <p>
              At LEO, we are deeply committed to the principles of sustainability and environmental stewardship.
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  const renderAdditionalText = () => {
    switch (currentIndex) {
      case 0:
        return <div className="additional-text-container">Endair Towers | Tripoli-Libya</div>;
      case 1:
        return <div className="additional-text-container">Al Ahly Mall | Benghazi-Libya</div>;
      case 2:
        return <div className="additional-text-container">Al Fadheel | Benghazi-Libya</div>;
      case 3:
        return <div className="additional-text-container">Tripoli Seafront | Tripoli-Libya</div>;
      case 4:
        return <div className="additional-text-container">Benghazi Modern Hospital | Benghazi - Libya</div>;
      case 5:
        return <div className="additional-text-container">Ouzu Hotel | Benghazi - Libya</div>;
      case 6:
        return <div className="additional-text-container">Sousa Resort | Sousa-Libya</div>;
      default:
        return null;
    }
  };

  return (
    <div className="gallery">

      <Carousel onSelect={handleSlideChange}>
        <Carousel.Item>
          <img className="d-block w-100" src="/Endair_Towers.jpg" alt="slide 1" />
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src="/AlAhly_Mall.jpg" alt="slide 2" />
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src="/AlFadheel_Urban_Center.jpg" alt="slide 3" />
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src="/Tripoli_Sea_Front_Towers.jpg" alt="slide 4" />
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src="/Benghazi_Modern_Hospital.jpg" alt="slide 5" />
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src="/Ozu_Hotel.jpg" alt="slide 6" />
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src="/Sousa_Resort.jpg" alt="slide 7" />
        </Carousel.Item>
      </Carousel>

      

      
      </div>

    
  );
}

export default Gallery;